export default class WorkItemType {
  id: string;

  name: string;

  definitionType: string;

  constructor(obj: any) {
    this.id = obj.id;
    this.name = obj.name;
    this.definitionType = obj.definitionType;
  }

  public static of(obj: any): WorkItemType {
    return new WorkItemType(obj);
  }

  public static ofList(obj: any): WorkItemType[] {
    return obj.map(this.of);
  }
}
